import { observer } from 'mobx-react-lite';
import { useCurrentUserStore } from '@yarmill/utils';
import { useEffect } from 'react';

export const Plausible = observer(function Plausible() {
  const currentUser = useCurrentUserStore();
  const role = currentUser.role;

  useEffect(() => {
    const element = document.querySelector<HTMLScriptElement>(
      '#plausible-tracking'
    );
    if (element) {
      element.setAttribute('event-role', role);
    }
  }, [role]);

  return null;
});
